import { jsx as o, jsxs as r } from "react/jsx-runtime";
import { clsx as c } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useRef as w, useEffect as I, useMemo as R } from "react";
import { useMobileNavigationToggle as M } from "../../utils/use-mobile-navigation-toggle.js";
import { RocheUIIcon as d } from "../icon/roche-icon.js";
import { isCurrentPage as C } from "../mobile-navigation/roche-mobile-navigation-helpers.js";
import i from "./roche-mobile-navigation-block.module.scss.js";
const j = ({
  id: e,
  link: s,
  depth: m,
  expanded: v,
  onToggle: p,
  isNavOpen: x,
  currentPage: b
}) => {
  const { nestedLinks: a, text: l, url: n } = s, g = !!(a != null && a.length), t = v.has(e), u = w(null), { show: f, hide: _ } = M(u);
  I(() => {
    u.current && (t ? f() : _());
  }, [t, f, _]);
  const k = R(() => `mobile-nav-panel-${e}`, [e]);
  if (!n && !g)
    return null;
  const h = C(n, b);
  return g ? /* @__PURE__ */ r("li", { className: c(i["mobile-navigation-block"], t && i["mobile-navigation-block--open"]), children: [
    /* @__PURE__ */ r(
      "button",
      {
        type: "button",
        className: i["mobile-navigation-block__button"],
        onClick: () => p(e),
        "aria-controls": k,
        "aria-expanded": t,
        children: [
          l,
          /* @__PURE__ */ o("span", { className: i["mobile-navigation-block__chevron"], children: /* @__PURE__ */ o(d, { icon: "chevron-down", height: "24px", decorative: !0 }) })
        ]
      }
    ),
    /* @__PURE__ */ r(
      "ul",
      {
        id: k,
        ref: u,
        className: c(
          i["mobile-navigation-block__submenu-list"],
          m > 0 && i[`mobile-navigation-block__submenu-list--depth-${m}`]
        ),
        children: [
          n && /* @__PURE__ */ o(
            "li",
            {
              className: c(
                i["mobile-navigation-block__submenu-item-title"],
                h && i["mobile-navigation-block__submenu-item-title--active"]
              ),
              children: /* @__PURE__ */ r(
                "a",
                {
                  className: i["mobile-navigation-block__submenu-item-link"],
                  href: n,
                  onClick: s.onClick,
                  "aria-label": l,
                  "aria-current": C(n, b) ? "page" : void 0,
                  children: [
                    l,
                    /* @__PURE__ */ o("span", { className: i["mobile-navigation-block__submenu-item-arrow"], children: /* @__PURE__ */ o(d, { icon: "arrow-right", height: "24px", decorative: !0 }) })
                  ]
                }
              )
            }
          ),
          a == null ? void 0 : a.map(($, N) => /* @__PURE__ */ o(
            j,
            {
              id: `${e}-${N}`,
              link: $,
              depth: m + 1,
              expanded: v,
              onToggle: p,
              isNavOpen: x,
              currentPage: b
            },
            `${e}-${N + 1}`
          ))
        ]
      }
    )
  ] }) : /* @__PURE__ */ o("li", { className: c(i["mobile-navigation-block"], h && i["mobile-navigation-block--active"]), children: /* @__PURE__ */ o(
    "a",
    {
      className: i["mobile-navigation-block__link"],
      href: n,
      onClick: s.onClick,
      "aria-current": h ? "page" : void 0,
      children: l
    }
  ) });
};
export {
  j as RocheUIMobileNavigationBlock
};
